<template>
  <div>
   <div class="searchBox">
    <!-- <div class="searchLeft">
      <el-select
        size="medium"
        v-model="searchForm.poolId"
        placeholder="请选择矿池"
        @change="getTableList"
        clearable 
      >
        <el-option
          v-for="item in pollList"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        ></el-option>
      </el-select>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div> -->
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
      <el-table-column
        type="index"
        width="60px"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="name"
        label="矿池名称">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="全部算力(TiB)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.maxPower,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="soldPower"
        label="已销售算力(TiB)">
      </el-table-column>
      <el-table-column
        prop="beSalePower"
        label="等待售算力(TiB)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.beSalePower,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        width="140px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="goDetl(scope.row.nodeNumbers)"><i class="el-icon-view" style="margin-right:3px;"></i>查看</el-button>
          <el-button size="mini" type="primary" @click="goCent(scope.row.id)"><i class="el-icon-view"></i>分币</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div> -->
    <el-dialog
      title="矿池节点"
      :visible.sync="dialogVisible"
      width="430px">
      <div>
        <span>当前节点：{{nodeNumbers}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        poolId: null,
        startTime: null,
        endTime: null,
      },
      tableData: [],
      pollList: [],
      dialogVisible: false,
      nodeNumbers: null
    };
  },
  created() {
    this.poolAll()
    this.getTableList()
  },
  methods: {
    goDetl(nodeNumbers) {
      this.nodeNumbers = nodeNumbers.join('、')
      this.dialogVisible = true
    },
    goCent(id) {
      this.$router.push({name:'centList',query:{id:id}})
    },
    async poolAll(){
      let res = await this.$http.nodePoolAll()
      if (res) {
        res.data.map((x)=>{
          this.pollList.push({
            key: x.id,
            label: x.name
          })
        })
      }
    },
    async getTableList(val){
       let res = await this.$http.nodePoolAllDetail();
        if (res) {
          this.tableData=res.data
          // this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
